import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ModalController } from 'ionic-angular';
import { Observable } from 'rxjs/Rx';

import { CustomerData } from '../types/session.type';
import { SessionService } from './session.service';
import { PDFService, ConvertHTMLToPDFResponse, PDFParams } from './pdf.service';
import { RegionService } from './region.service';

export interface EmailParams {
  subject: string | null | undefined;
  message: string | null | undefined;
  to: string | null | undefined;
  from?: string | null | undefined;
  cc: string | null | undefined;
  bcc: string | null | undefined;
}

@Injectable()
export class RecommendationService {
  constructor(
    private pdfService: PDFService,
    public sessionService: SessionService,
    public modalCtrl: ModalController,
    public regionService: RegionService,
    private http: HttpClient
  ) {}

  private getCustomerData(): CustomerData {
    const customerData: CustomerData = new CustomerData({
      firstName: this.sessionService.firstName.model,
      lastName: this.sessionService.lastName.model,
      email: this.sessionService.customerEmail.model,
      doctor: this.sessionService.doctor.model,
      phone: this.sessionService.phone.model,
      downloadURL: this.sessionService.downloadURL,
    });
    return customerData;
  }

  uploadRecommendation(pdfBody: string): Observable<void> {
    return new Observable<void>((observer) => {
      this.createPDF(pdfBody).subscribe((pdfResponse: ConvertHTMLToPDFResponse | string) => {
        if (pdfResponse) {
          console.log(pdfResponse, 'pdfResponse');
          if (typeof pdfResponse === 'string') {
            this.sessionService.downloadURL = pdfResponse;
            observer.next();
            observer.complete();
          } else {
            observer.next();
            observer.complete();
          }
        } else {
          observer.next();
          observer.complete();
        }
      });
    });
  }

  private createPDF(pdfBody: string): Observable<ConvertHTMLToPDFResponse> {
    return new Observable<ConvertHTMLToPDFResponse>((observer) => {
      const pdfParams: PDFParams = {
        title: this.regionService.language['RecommendationFile'],
        html: pdfBody,
        styleUrl: './assets/pdf/style.css',
      };

      this.pdfService.createPDF(pdfParams).subscribe(
        (response: ConvertHTMLToPDFResponse) => {
          observer.next(response);
          observer.complete();
        },
        (e: string) => observer.error(e)
      );
    });
  }

  email(emailBody: string): Observable<void> {
    return new Observable<void>((observer) => {
      const self = this;

      function complete(): void {
        observer.next();
        observer.complete();
      }

      const subject = `${this.sessionService.firstName.model ? this.sessionService.firstName.model : ''} ${
        this.sessionService.lastName.model ? this.sessionService.lastName.model : ''
      } ${this.regionService.language['Zeiss Lens Recommendation']}`;
      const emailParams: EmailParams = {
        subject: subject,
        message: emailBody,
        to: this.sessionService.customerEmail.model.toString(),
        from: 'zeiss@imsmartapp.com',
        cc: this.sessionService.doctor.model ? this.sessionService.doctor.model.toString() : '',
        bcc: '',
      };
      console.log(this.sessionService.downloadURL);
      let emailTemplate = `mailto:${this.sessionService.customerEmail.model.toString()}?`;

      // subject
      emailTemplate += `Subject=${this.sessionService.firstName.model ? this.sessionService.firstName.model : ''} ${
        this.sessionService.lastName.model ? this.sessionService.lastName.model : ''
      } ${this.regionService.language['Zeiss Lens Recommendation']}`;

      // cc
      if (this.sessionService.doctor.model) emailTemplate += `&cc=${this.sessionService.doctor.model.toString()}`;

      // body
      emailTemplate += `&Body=ZEISS%20lens%20recommendation:%20${this.sessionService.downloadURL
        .replace(/%/g, '%25')
        .replace(/&/g, '%26')}`;
      console.log('emailTemplate', emailTemplate);

      window.location.href = emailTemplate;
      complete();
    });
  }

  sms(pdfBody: string): Observable<void> {
    return new Observable<void>((observer) => {
      this.uploadRecommendation(pdfBody).subscribe(() => {
        console.log('in sms fn');
        const customerData: CustomerData = this.getCustomerData();
        let subscribeMessage = 'Message and data rates may apply. Text HELP to 21397 for help. Text STOP to 21397 to cancel.';
        customerData.message = `${this.regionService.language['Zeiss Lens Recommendation']} ${this.sessionService.downloadURL}. ${subscribeMessage}`;
        console.log(customerData, 'customerData');

        this.http
          .get(
            'https://us-central1-cn-test-9e910.cloudfunctions.net/sendMessage?phone=' +
              encodeURIComponent(customerData.phone.toString()) +
              '&message=' +
              encodeURIComponent(customerData.message)
          )
          .subscribe(
            (res: any) => {
              console.log('Res', res);
              observer.next();
              observer.complete();
            },
            (error: Error) => {
              console.log('error');
              observer.error(error);
              observer.complete();
            },
            () => {
              console.log('complete');
            }
          );
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/recommendation.service.ts